import { render, staticRenderFns } from "./perte-de-cles.vue?vue&type=template&id=52063c80"
import script from "./perte-de-cles.vue?vue&type=script&lang=ts"
export * from "./perte-de-cles.vue?vue&type=script&lang=ts"
import style0 from "./perte-de-cles.vue?vue&type=style&index=0&id=52063c80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports